import * as tslib_1 from "tslib";
export var GroupsRequestSort;
(function (GroupsRequestSort) {
    GroupsRequestSort["MEMBERS_COUNT"] = "members_count";
    GroupsRequestSort["RECENT_ACTIVITY"] = "recent_activity_date";
    GroupsRequestSort["NAME"] = "title";
})(GroupsRequestSort || (GroupsRequestSort = {}));
var GroupsRequestBuilder = /** @class */ (function () {
    function GroupsRequestBuilder() {
        this.query = {};
    }
    GroupsRequestBuilder.prototype.addSort = function (fieldName, order) {
        if (order === void 0) { order = null; }
        this.query.sort = tslib_1.__spread((this.query.sort || []), [{ fieldName: fieldName, order: order }]);
        return this;
    };
    GroupsRequestBuilder.prototype.addPaging = function (limit, offset) {
        if (offset === void 0) { offset = null; }
        this.query.paging = { limit: limit, offset: offset };
        return this;
    };
    GroupsRequestBuilder.prototype.addFilter = function (filter) {
        this.query.filter = this.query.filter || {};
        Object.assign(this.query.filter, filter);
        return this;
    };
    GroupsRequestBuilder.prototype.sortByMembersCount = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.MEMBERS_COUNT, order);
    };
    GroupsRequestBuilder.prototype.sortByRecentActivity = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.RECENT_ACTIVITY, order);
    };
    GroupsRequestBuilder.prototype.sortByName = function (order) {
        if (order === void 0) { order = null; }
        return this.addSort(GroupsRequestSort.NAME, order);
    };
    GroupsRequestBuilder.prototype.build = function () {
        return { query: this.query };
    };
    return GroupsRequestBuilder;
}());
export { GroupsRequestBuilder };
//# sourceMappingURL=GroupsRequestBuilder.js.map